import React from 'react';
import styled from 'styled-components';
import { Typography } from 'src/typography';
import Imgix from 'shared/components/imgix';

type CollectionsHeaderProps = {
  title: string;
  description?: string;
  image?: string;
  customCategory?: boolean;
};

const imgixParams = {
  h: 296,
  w: 1940,
  fit: 'crop',
};

export const CollectionsHeader = ({
  title,
  description,
  image,
  customCategory,
}: CollectionsHeaderProps): JSX.Element => (
  <>
    {!customCategory && (
      <Wrapper>
        <Heading tag='h1' size='medium'>
          {title}
        </Heading>

        {description && <Description size='large'>{description}</Description>}

        {image && (
          <ImageWrapper>
            <Image src={image} alt={title} imgixParams={imgixParams} disableSrcSet />
          </ImageWrapper>
        )}
      </Wrapper>
    )}
  </>
);

const Wrapper = styled.div`
  margin: 0 0 24px;
  width: 100%;
`;

const Heading = styled(Typography.Heading)`
  margin: 0;
`;

const Description = styled(Typography.Body)`
  color: #4b5257;
  margin-top: 8px;
`;

const ImageWrapper = styled.div`
  border-radius: ${({ theme }) => theme.customized.radius.lg};
  height: 148px;
  margin: 16px 0 0;
  max-width: 970px;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const Image = styled(Imgix)`
  display: block;
  height: 100%;
  left: 50%;
  max-width: none;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
`;
